export default __webpack_public_path__ + "static/media/fastFood04.e245d63c.png";